<p-button (onClick)="showDialog = true" icon="pi pi-link"></p-button>

<p-dialog
  *ngIf="showDialog"
  [resizable]="false"
  [(visible)]="showDialog"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '100vw', height: '100vh' }"
  appendTo="body"
>
  <h2>Odaberite jedinicu gradiva</h2>
  <app-odaberi-jedinicu
    (itemSelected)="onSelectedItem($event)"
  ></app-odaberi-jedinicu>
</p-dialog>
